<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="代付订单列表" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <el-form
              class="jc-table-actionBar-item"
              :inline="true"
              :model="form"
              ref="form"
            >
              <el-form-item label="PIN：" prop="pin">
                <el-input v-model.trim="form.pin"></el-input>
              </el-form-item>

              <el-form-item label="付款方式：" prop="payType">
                <el-select
                  v-model="form.payType"
                  placeholder="请选择"
                  clearable
                  @change="getList"
                >
                  <el-option
                    v-for="[key, value] of Object.entries(PAY_TYPE)"
                    :key="key"
                    :label="value"
                    :value="key"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="订单状态：" prop="status">
                <el-select
                  v-model="form.status"
                  placeholder="请选择"
                  clearable
                  @change="getList"
                  class="accountSelect"
                >
                  <el-option
                    v-for="[key, value] of Object.entries(STATUS)"
                    :key="key"
                    :label="value"
                    :value="key"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="代付状态：" prop="agentPayStatus">
                <el-select
                  v-model="form.agentPayStatus"
                  placeholder="请选择"
                  clearable
                  @change="getList"
                >
                  <el-option
                    v-for="[key, value] of Object.entries(AGENT_PAY_TYPE)"
                    :key="key"
                    :label="value"
                    :value="key"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="下单时间：">
                <el-date-picker
                  v-model="daterange"
                  type="daterange"
                  placeholder="选择日期范围"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label="订单编号：" prop="orderNumber">
                <el-input v-model.trim="form.orderNumber"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="search">查询</el-button>

                <el-button type="primary" @click="resetFields">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column prop="orderNumber" label="订单编号">
              <template slot-scope="scope">{{
                scope.row.orderNumber | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="pin" label="PIN">
              <template slot-scope="scope">{{
                scope.row.pin | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="loginName" label="账号名称">
              <template slot-scope="scope">{{
                scope.row.loginName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="payType" label="付款方式">
              <template slot-scope="scope">{{
                PAY_TYPE_MAP[scope.row.payType]
              }}</template>
            </el-table-column>

            <el-table-column prop="serviceName" label="产品名称">
              <template slot-scope="scope">{{
                scope.row.appName + '-' + scope.row.serviceName
              }}</template>
            </el-table-column>

            <el-table-column prop="createTime" label="下单时间" width="150px">
              <template slot-scope="scope">{{
                scope.row.createTime | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="payTime" label="支付/开通时间" width="150px">
              <template slot-scope="scope">{{
                scope.row.payTime | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="status" label="订单状态">
              <template slot-scope="scope">{{
                STATUS[scope.row.status] | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="agentPayStatus" label="代付状态">
              <template slot-scope="scope">{{
                AGENT_PAY_TYPE[scope.row.agentPayStatus] | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="totalFee" label="原价" width="110">
              <template slot-scope="scope">{{
                scope.row.totalFee | filterParams
              }}</template>
            </el-table-column>

            <el-table-column prop="actualFee" label="应付金额">
              <template slot-scope="scope">{{
                scope.row.actualFee | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="goPay(scope.row.orderNumber)"
                  v-if="
                    scope.row.agentPayStatus ===
                      AGENT_PAY_TYPE_MAP.APPLY_AGENT &&
                    scope.row.status === STATUS_ENUM.NO_PAY
                  "
                  >支付</el-button
                >

                <!-- 若代付状态为“已申请”，订单状态为“未支付”，可支付/驳回。 -->
                <el-button
                  type="text"
                  @click="refuse(scope.row.orderNumber)"
                  v-if="
                    scope.row.agentPayStatus ===
                      AGENT_PAY_TYPE_MAP.APPLY_AGENT &&
                    scope.row.status === STATUS_ENUM.NO_PAY
                  "
                >
                  驳回
                </el-button>

                <router-link
                  :to="{
                    name: 'partnerDetail',
                    params: { orderNumber: scope.row.orderNumber },
                  }"
                  >详情</router-link
                >
              </template>
            </el-table-column>
          </el-table>
          <div
            class="jc-container-table-actionBar text-right"
            style="margin-top: 16px"
            v-if="total > 10"
          >
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageNumber"
              :page-sizes="[10, 20, 50]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPartnerOrderList, cancelAgentPay } from '@/api/distributor-api.js'
import {
  STATUS,
  AGENT_PAY_TYPE,
  AGENT_PAY_TYPE_MAP,
  STATUS_ENUM,
  PAY_TYPE,
  PAY_TYPE_MAP,
} from '@/utils/constant'
import { handleFalsyToParams } from '../../utils/helper'
export default {
  data() {
    return {
      currentPage1: 1,
      STATUS,
      AGENT_PAY_TYPE,
      AGENT_PAY_TYPE_MAP,
      STATUS_ENUM,
      PAY_TYPE,
      PAY_TYPE_MAP,
      form: {
        pin: '',
        status: '',
        startTime: '',
        endTime: '',
        orderNumber: '',
        payType: '',
        agentPayStatus: '',
        pageSize: 10,
        pageNumber: 1,
      },
      daterange: '',
      total: 0,
      tableData: [],
    }
  },
  watch: {
    daterange(curVal) {
      if (curVal.length) {
        this.form.startTime = (curVal[0] && curVal[0].getTime()) || ''
        this.form.endTime = (curVal[1] && curVal[1].getTime() + 86399000) || ''
      } else {
        this.form.startTime = ''
        this.form.endTime = ''
      }
    },
  },
  created() {
    this.getList()
  },
  methods: {
    search() {
      this.form.pageNumber = 1
      this.getList()
    },
    resetFields() {
      this.daterange = ''
      this.$refs.form.resetFields()
    },
    handleSizeChange(val) {
      this.form.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.form.pageNumber = val
      this.getList()
    },
    async getList() {
      try {
        const params = handleFalsyToParams(this.form)
        let { result = {} } = await getPartnerOrderList({
          version: 'orderV2',
          params: {
            ...params,
          },
        })
        this.tableData = result.resultList || []
        this.total = result.totalCount || 0
      } catch (e) {
        console.log(e)
        this.tableData = []
        this.total = 0
      }
    },
    goPay(orderNumber) {
      const url = `${derivativeConfig.orderUrl}?orderId=${orderNumber}`
      window.open(url)
    },
    async refuse(orderNumber) {
      const { result = {} } = await cancelAgentPay({
        version: 'orderV2',
        params: {
          orderNumber,
        },
      })
      // 0取消失败 1取消成功
      if (result.data) {
        this.$message.success('驳回成功')
        this.getList()
      } else {
        this.$message.error('驳回失败')
      }
    },
  },
}
</script>

<style scoped="true">
.jc-container-table-actionBar >>> .jc-table-actionBar-item {
  margin-right: 0px;
}
.jc-table-actionBar-item >>> .jc-input {
  width: 140px;
}
.accountSelect >>> .jc-input {
  width: 90px;
}
</style>
